import React from "react";
import { useNavigate } from "react-router-dom";
import "./PrivacyPolicy.css"; // Make sure the filename includes .css

const RefundPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="refund-policy-container">
      <button className="back-button" onClick={() => navigate(-1)}>
        ← Back
      </button>
      
      <h1>Return and Refund Policy</h1>

      <p>
        Thank you for choosing Arrow Digital Marketing. We strive to provide the best services to our clients.
      </p>

      <h2>No Refund Policy</h2>
      <p>
        Please note that all purchases made with Arrow Digital Marketing are final. 
        We do not offer returns, refunds, or cancellations under any circumstances, 
        once a purchase or service agreement is completed.
      </p>

      <h2>Exceptions</h2>
      <p>
        In rare cases where a refund is considered, it will be reviewed at the sole discretion 
        of Arrow Digital Marketing. Any such decision will be final and non-negotiable.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions or concerns regarding this policy, feel free to reach out to us at{" "}
        <a href="mailto:anup@arrowdigital.com.au">anup@arrowdigital.com.au</a>.
      </p>

      <button className="back-button" onClick={() => navigate(-1)}>
        ← Back
      </button>
    </div>
  );
};

export default RefundPolicy;
